/* SK Megamenu */
(function () {
  'use strict';

  var HOVER_CLOSE_DELAY = 150;
  var DESKTOP_BREAKPOINT = 1280;

  function initMegamenu(root) {
    /* R45: guard contra doble inicializacion */
    if (root.dataset.skInit) return;
    root.dataset.skInit = 'true';

    var panels = root.querySelectorAll('[data-sk-megamenu-panel]');
    var overlay = root.querySelector('[data-sk-megamenu-overlay]');
    var drawer = root.querySelector('[data-sk-megamenu-drawer]');
    var drawerInner = drawer ? drawer.querySelector('.sk-megamenu__drawer-inner') : null;

    /* Triggers: los links del header que deben abrir dropdown.
       Se buscan en DOCUMENT porque el header es hermano del megamenu.
       R47 excepcion justificada: los triggers pertenecen al header-group pero
       deben comunicarse con el megamenu. Se filtran por proximidad. */
    var triggers = document.querySelectorAll('[data-sk-megamenu-trigger]');
    var drawerOpeners = document.querySelectorAll('[data-sk-megamenu-drawer-open]');

    var activePanel = null;
    var activeTrigger = null;
    var closeTimer = null;
    var isPinned = false;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ==========================================================
       Helpers
       ========================================================== */

    function isDesktop() {
      return window.innerWidth >= DESKTOP_BREAKPOINT;
    }

    function getPanelByHandle(handle) {
      if (!handle) return null;
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-sk-megamenu-panel') === handle) {
          return panels[i];
        }
      }
      return null;
    }

    function getTriggerByHandle(handle) {
      for (var i = 0; i < triggers.length; i++) {
        if (triggers[i].getAttribute('data-sk-megamenu-trigger') === handle) {
          return triggers[i];
        }
      }
      return null;
    }

    function clearCloseTimer() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    /* ==========================================================
       Desktop: abrir / cerrar paneles
       ========================================================== */

    function openPanel(panel, trigger) {
      if (!panel) return;
      clearCloseTimer();

      /* Cerrar panel activo si es otro */
      if (activePanel && activePanel !== panel) {
        closePanel(activePanel, activeTrigger, true);
      }

      panel.hidden = false;
      /* Forzar reflow para transicion */
      void panel.offsetWidth;
      panel.setAttribute('aria-hidden', 'false');

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }

      if (overlay) {
        overlay.hidden = false;
        void overlay.offsetWidth;
        overlay.setAttribute('aria-hidden', 'false');
      }

      activePanel = panel;
      activeTrigger = trigger || null;
    }

    function closePanel(panel, trigger, immediate) {
      if (!panel) return;
      clearCloseTimer();

      panel.setAttribute('aria-hidden', 'true');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      var hide = function () {
        panel.hidden = true;
      };

      if (immediate || prefersReducedMotion) {
        hide();
      } else {
        setTimeout(hide, 220);
      }

      if (panel === activePanel) {
        activePanel = null;
        activeTrigger = null;
        isPinned = false;

        if (overlay) {
          overlay.setAttribute('aria-hidden', 'true');
          var hideOverlay = function () {
            overlay.hidden = true;
          };
          if (immediate || prefersReducedMotion) {
            hideOverlay();
          } else {
            setTimeout(hideOverlay, 220);
          }
        }
      }
    }

    function closeAllPanels(immediate) {
      if (activePanel) {
        closePanel(activePanel, activeTrigger, immediate);
      }
    }

    function scheduleClose() {
      clearCloseTimer();
      closeTimer = setTimeout(function () {
        if (!isPinned) closeAllPanels(false);
      }, HOVER_CLOSE_DELAY);
    }

    /* ==========================================================
       Listeners desktop: triggers (hover + click)
       ========================================================== */

    function bindTrigger(trigger) {
      var handle = trigger.getAttribute('data-sk-megamenu-trigger');
      var panel = getPanelByHandle(handle);
      if (!panel) return;

      /* El trigger puede ser un <summary> de un <details>. En ese caso queremos
         prevenir el comportamiento nativo (abrir el details) cuando estamos
         en desktop para usar nuestro panel en su lugar. */
      var parentDetails = trigger.closest('details');

      /* Mouse enter → abrir (si desktop).
         Usamos pointerenter (moderno, fiable con <summary>) + mouseenter como fallback.
         Si ambos disparan seguidos, openPanel es idempotente. */
      var onEnter = function () {
        if (!isDesktop()) return;
        clearCloseTimer();
        openPanel(panel, trigger);
      };
      trigger.addEventListener('pointerenter', onEnter);
      trigger.addEventListener('mouseenter', onEnter);

      /* Mouse leave → programar cierre */
      var onLeave = function () {
        if (!isDesktop()) return;
        if (isPinned) return;
        scheduleClose();
      };
      trigger.addEventListener('pointerleave', onLeave);
      trigger.addEventListener('mouseleave', onLeave);

      /* Click → toggle (fijar si estaba abierto por hover) */
      trigger.addEventListener('click', function (e) {
        if (!isDesktop()) return;
        e.preventDefault();
        /* Cerrar el details nativo si acaba de abrirse */
        if (parentDetails && parentDetails.open) {
          parentDetails.open = false;
        }
        if (activePanel === panel) {
          if (isPinned) {
            isPinned = false;
            closePanel(panel, trigger, false);
          } else {
            isPinned = true;
          }
        } else {
          openPanel(panel, trigger);
          isPinned = true;
        }
      });

      /* Estado inicial accesibilidad */
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', 'sk-megamenu-panel-' + handle);
      panel.id = 'sk-megamenu-panel-' + handle;
    }

    /* ==========================================================
       Listeners desktop: paneles (mouse enter cancela cierre)
       ========================================================== */

    function bindPanel(panel) {
      var onPanelEnter = function () {
        if (!isDesktop()) return;
        clearCloseTimer();
      };
      panel.addEventListener('pointerenter', onPanelEnter);
      panel.addEventListener('mouseenter', onPanelEnter);

      var onPanelLeave = function () {
        if (!isDesktop()) return;
        if (isPinned) return;
        scheduleClose();
      };
      panel.addEventListener('pointerleave', onPanelLeave);
      panel.addEventListener('mouseleave', onPanelLeave);
    }

    /* ==========================================================
       Overlay click → cerrar
       ========================================================== */

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeAllPanels(false);
      });
    }

    /* ==========================================================
       ESC → cerrar
       ========================================================== */

    function onKeydown(e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;

      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
        return;
      }

      if (activePanel) {
        closeAllPanels(false);
        if (activeTrigger) activeTrigger.focus();
      }
    }

    document.addEventListener('keydown', onKeydown);

    /* ==========================================================
       Click fuera → cerrar desktop
       ========================================================== */

    function onDocClick(e) {
      if (!isDesktop()) return;
      if (!activePanel) return;

      var target = e.target;
      if (activePanel.contains(target)) return;
      if (activeTrigger && activeTrigger.contains(target)) return;

      /* No cerrar si se hizo click en otro trigger (ya lo manejan ellos) */
      for (var i = 0; i < triggers.length; i++) {
        if (triggers[i].contains(target)) return;
      }

      closeAllPanels(false);
    }

    document.addEventListener('click', onDocClick);

    /* ==========================================================
       Drawer mobile
       ========================================================== */

    var drawerBackButtons = drawer ? drawer.querySelectorAll('[data-sk-drawer-back]') : [];
    var drawerCloseButtons = drawer ? drawer.querySelectorAll('[data-sk-drawer-close]') : [];
    var drawerOpenViewButtons = drawer ? drawer.querySelectorAll('[data-sk-drawer-open-view]') : [];
    var drawerAccordions = drawer ? drawer.querySelectorAll('[data-sk-drawer-accordion-toggle]') : [];
    var drawerViews = drawer ? drawer.querySelectorAll('[data-sk-drawer-view]') : [];

    var drawerFocusTrapElements = [];
    var drawerLastFocused = null;

    function getDrawerView(name) {
      for (var i = 0; i < drawerViews.length; i++) {
        if (drawerViews[i].getAttribute('data-sk-drawer-view') === name) {
          return drawerViews[i];
        }
      }
      return null;
    }

    function showDrawerView(name) {
      for (var i = 0; i < drawerViews.length; i++) {
        var v = drawerViews[i];
        var n = v.getAttribute('data-sk-drawer-view');
        if (n === name) {
          /* Si estaba oculto (display:none), hay que dejar que el browser
             renderice el estado inicial (translateX(100%)) ANTES de añadir
             la clase --active. Sin esto, la transition no dispara en forward. */
          var wasHidden = v.hidden;
          v.hidden = false;
          v.setAttribute('aria-hidden', 'false');
          v.scrollTop = 0;
          if (wasHidden) {
            /* Forzar reflow para que el browser capture el estado inicial */
            void v.offsetWidth;
          }
          v.classList.add('sk-megamenu__drawer-view--active');
          v.classList.remove('sk-megamenu__drawer-view--out-left');
        } else if (name !== 'root' && n === 'root') {
          v.classList.remove('sk-megamenu__drawer-view--active');
          v.classList.add('sk-megamenu__drawer-view--out-left');
          v.setAttribute('aria-hidden', 'true');
        } else {
          v.classList.remove('sk-megamenu__drawer-view--active');
          v.classList.remove('sk-megamenu__drawer-view--out-left');
          v.setAttribute('aria-hidden', 'true');
          if (!prefersReducedMotion) {
            setTimeout((function (el) {
              return function () {
                if (!el.classList.contains('sk-megamenu__drawer-view--active')) {
                  el.hidden = true;
                }
              };
            })(v), 220);
          } else {
            v.hidden = true;
          }
        }
      }
    }

    function openDrawer() {
      if (!drawer) return;
      drawerLastFocused = document.activeElement;

      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sk-megamenu-body-locked');

      showDrawerView('root');

      /* Focus en el primer link focusable */
      var first = drawer.querySelector('.sk-megamenu__drawer-close');
      if (first) first.focus();

      /* Actualizar elementos focusables para trap */
      updateDrawerFocusables();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sk-megamenu-body-locked');

      /* Colapsar todos los accordions abiertos */
      for (var i = 0; i < drawerAccordions.length; i++) {
        drawerAccordions[i].setAttribute('aria-expanded', 'false');
      }

      /* Resetear aria-expanded de los root-link buttons */
      for (var j = 0; j < drawerOpenViewButtons.length; j++) {
        drawerOpenViewButtons[j].setAttribute('aria-expanded', 'false');
      }

      /* Volver a la vista raiz */
      showDrawerView('root');

      var hide = function () {
        drawer.hidden = true;
      };

      if (prefersReducedMotion) {
        hide();
      } else {
        setTimeout(hide, 240);
      }

      /* Restaurar foco */
      if (drawerLastFocused && drawerLastFocused.focus) {
        try {
          drawerLastFocused.focus();
        } catch (err) {}
      }
    }

    function updateDrawerFocusables() {
      if (!drawer) return;
      /* Incluir input/select/textarea para que buscador y locale select entren al focus trap */
      var selector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      drawerFocusTrapElements = Array.prototype.slice.call(
        drawer.querySelectorAll(selector)
      ).filter(function (el) {
        if (el.hasAttribute('hidden')) return false;
        /* Verificar que el ancestro no este hidden */
        var parent = el.parentElement;
        while (parent && parent !== drawer) {
          if (parent.hasAttribute('hidden')) return false;
          parent = parent.parentElement;
        }
        return true;
      });
    }

    /* Focus trap en drawer */
    function onDrawerKeydown(e) {
      if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
      if (e.key !== 'Tab' && e.keyCode !== 9) return;

      updateDrawerFocusables();
      if (drawerFocusTrapElements.length === 0) return;

      var first = drawerFocusTrapElements[0];
      var last = drawerFocusTrapElements[drawerFocusTrapElements.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    if (drawer) {
      drawer.addEventListener('keydown', onDrawerKeydown);
    }

    /* Listeners drawer */
    for (var c = 0; c < drawerCloseButtons.length; c++) {
      drawerCloseButtons[c].addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    }

    for (var b = 0; b < drawerBackButtons.length; b++) {
      drawerBackButtons[b].addEventListener('click', function (e) {
        e.preventDefault();
        /* Resetear aria-expanded de todos los root-link buttons al volver */
        for (var rb = 0; rb < drawerOpenViewButtons.length; rb++) {
          drawerOpenViewButtons[rb].setAttribute('aria-expanded', 'false');
        }
        showDrawerView('root');
        updateDrawerFocusables();
      });
    }

    for (var ov = 0; ov < drawerOpenViewButtons.length; ov++) {
      (function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var target = btn.getAttribute('data-sk-drawer-open-view');
          if (!target) return;
          btn.setAttribute('aria-expanded', 'true');
          showDrawerView(target);
          updateDrawerFocusables();
        });
      })(drawerOpenViewButtons[ov]);
    }

    /* Accordions dentro del drawer */
    for (var a = 0; a < drawerAccordions.length; a++) {
      (function (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          updateDrawerFocusables();
        });
      })(drawerAccordions[a]);
    }

    /* ==========================================================
       Abrir drawer desde el header (hamburger mobile)
       ========================================================== */

    for (var d = 0; d < drawerOpeners.length; d++) {
      drawerOpeners[d].addEventListener('click', function (e) {
        if (isDesktop()) return;
        e.preventDefault();
        openDrawer();
      });
    }

    /* ==========================================================
       Triggers del header tambien abren drawer en mobile
       ========================================================== */

    for (var t = 0; t < triggers.length; t++) {
      bindTrigger(triggers[t]);

      /* En mobile, al hacer click en un trigger del header se abre el drawer
         y se navega directamente a la vista de esa categoria */
      (function (tr) {
        tr.addEventListener('click', function (e) {
          if (isDesktop()) return;
          e.preventDefault();
          var handle = tr.getAttribute('data-sk-megamenu-trigger');
          openDrawer();
          if (handle) {
            setTimeout(function () {
              showDrawerView(handle);
              updateDrawerFocusables();
            }, 50);
          }
        });
      })(triggers[t]);
    }

    /* ==========================================================
       Panels: bind listeners (hover cancela cierre)
       ========================================================== */

    for (var p = 0; p < panels.length; p++) {
      bindPanel(panels[p]);
    }

    /* ==========================================================
       Resize: si cambia de desktop a mobile o al reves, cerrar todo
       ========================================================== */

    var lastIsDesktop = isDesktop();
    function onResize() {
      var currentIsDesktop = isDesktop();
      if (currentIsDesktop !== lastIsDesktop) {
        closeAllPanels(true);
        if (drawer && drawer.getAttribute('aria-hidden') === 'false' && currentIsDesktop) {
          closeDrawer();
        }
        lastIsDesktop = currentIsDesktop;
      }
    }

    window.addEventListener('resize', onResize);

    /* ==========================================================
       Animacion de accordions de subcategorias dentro de cada panel
       ========================================================== */
    var accordions = root.querySelectorAll('.sk-megamenu__subgroup--accordion');
    for (var a = 0; a < accordions.length; a++) {
      (function (details) {
        var summary = details.querySelector('summary');
        var content = details.querySelector('.sk-megamenu__items');
        if (!summary || !content) return;

        summary.addEventListener('click', function (e) {
          if (prefersReducedMotion) return; /* comportamiento nativo sin animacion */
          e.preventDefault();

          var isOpen = details.hasAttribute('open');

          if (isOpen) {
            /* Cerrando: de scrollHeight actual a 0 */
            var h = content.scrollHeight;
            content.style.maxHeight = h + 'px';
            content.offsetHeight; /* forzar reflow */
            content.style.maxHeight = '0px';
            var onEnd = function () {
              details.removeAttribute('open');
              content.style.maxHeight = '';
              content.removeEventListener('transitionend', onEnd);
            };
            content.addEventListener('transitionend', onEnd);
          } else {
            /* Abriendo: de 0 a scrollHeight */
            details.setAttribute('open', '');
            content.style.maxHeight = '0px';
            content.offsetHeight; /* forzar reflow */
            content.style.maxHeight = content.scrollHeight + 'px';
            var onEnd2 = function () {
              content.style.maxHeight = '';
              content.removeEventListener('transitionend', onEnd2);
            };
            content.addEventListener('transitionend', onEnd2);
          }
        });
      })(accordions[a]);
    }
  }

  /* R44: inicializar TODAS las instancias */
  function initAll(context) {
    var ctx = context || document;
    var roots = ctx.querySelectorAll('[data-sk-megamenu]');
    for (var i = 0; i < roots.length; i++) {
      initMegamenu(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* R48: re-iniciar en el Customizer */
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) {
      var el = e.target.querySelector ? e.target.querySelector('[data-sk-megamenu]') : null;
      if (el) {
        /* Forzar re-init reseteando el guard */
        delete el.dataset.skInit;
        initMegamenu(el);
      } else {
        /* Puede haber cambiado el header: re-escanear todo */
        initAll();
      }
    }
  });
})();
